import React from "react";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  CopyIcon,
  DeleteIcon,
  LowInventoryAlertIcon,
} from "../../../components/common/iconography";

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const ProductCreateHelp = () => {
  const classes = useStyles();

  return (
    <>
      <Typography>
        Manually creating a new Product can be done from scratch, or by cloning
        an existing, similar Product.
      </Typography>
      <ul>
        <li>
          <Typography>
            <strong>Product Name: </strong> Descriptive product name. If product
            comes as a UNIT/Bundle, we commend adding # of PIECES in product
            name.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Product Code: </strong> a unique, manufacturer-provided SKU,
            Product Code, or UPC registered with GS1 US. Once product is created
            or imported, a Product Code cannot be modified.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Load Type: </strong> Select from pre-configured set of
            product Load Types.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Commodity Category: </strong> Custom Product / commodity
            categorization.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Low Inventory Alert: </strong> Inventory quantity threshold
            at which the <LowInventoryAlertIcon className={classes.icon} /> "Low
            Inventory Alert" is triggered.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>UOM: </strong> Units of measure used to count/measure
            inventory levels. A corresponding unit of measure should be filled
            with "1" as a unit-to-unit conversion base.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Billing Units: </strong> Units of measure used to
            count/measure inventory for billing purposes. Can be different from
            Default UOM. For excample, you can measure inventory in Gallons, but
            bill customer in Lbs. A corresponding unit of measure should be
            filled with amount corresponding to 1 Default Unit.
          </Typography>
        </li>
        <li>
          <Typography variant="overline">
            <strong>CUSTOM FIELDS: </strong>
          </Typography>
          <Typography>
            Product Catalog supports definition of Custom Fields to extend the
            capabilities of the platform. Custom Fields can be added directly
            through a Product Catalog import, and defined in Account "CUSTOM
            SETTINGS" tab. To add a new Custom Field, navigate to the "INVENTORY
            FIELDS" section and enter it there.
          </Typography>
        </li>
      </ul>
    </>
  );
};

export const ProductEditHelp = () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="overline"></Typography>
      <ul>
        <li>
          <Typography>
            <strong>Product Name: </strong> Descriptive product name. If product
            comes as a UNIT/Bundle, we commend adding # of PIECES in product
            name.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Product Code: </strong> a unique, manufacturer-provided SKU,
            Product Code, or UPC registered with GS1 US. Once product is created
            or imported, a Product Code cannot be modified.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Load Type: </strong> Select from pre-configured set of
            product Load types.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Commodity Category: </strong> Custom Product / commodity
            categorization.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Low Inventory Alert: </strong> Inventory quantity threshold
            at which the <LowInventoryAlertIcon className={classes.icon} /> "Low
            Inventory Alert" is triggered.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>UOM: </strong> Units of measure used to count/measure
            inventory levels. A corresponding unit of measure should be filled
            with "1" as a unit-to-unit conversion base.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Billing Units: </strong> Units of measure used to
            count/measure inventory for billing purposes. Can be different from
            Default UOM. For excample, you can measure inventory in Gallons, but
            bill customer in Lbs. A corresponding unit of measure should be
            filled with amount corresponding to 1 Default Unit.
          </Typography>
        </li>
        <li>
          <Typography variant="overline">
            <strong>CUSTOM FIELDS: </strong>
          </Typography>
          <Typography>
            Product Catalog supports definition of Custom Fields to extend the
            capabilities of the platform. Custom Fields can be added directly
            through a Product Catalog import, and defined in Account "CUSTOM
            SETTINGS" tab. To add a new Custom Field, navigate to the "INVENTORY
            FIELDS" section and enter it there.
          </Typography>
        </li>
        <li>
          <Typography>
            <CopyIcon className={classes.icon} />
            <strong> CLONE: </strong>
            Copy current record to create a new Product. Cloned product needs to
            have a unique Product Code added.
          </Typography>
        </li>
        <li>
          <Typography>
            <DeleteIcon className={classes.icon} />
            <strong> DELETE: </strong>
            Removes the Product from the platform making it unavailable for
            future use. It does not affect past inventory records linked to this
            Product.
          </Typography>
        </li>
      </ul>
    </>
  );
};
